import { faHeart as faHeartRegular } from "@fortawesome/pro-regular-svg-icons";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled, Theme } from "@mui/material/styles";

import { TileButton, TileButtonProps } from "./TileButton";

interface TileLikeButtonProps extends TileButtonProps {
  isLiked?: boolean;
  isLoading?: boolean;
  onAction: (event: React.MouseEvent, action: "LIKE") => void;
}

const getBackgroundColor = (isLiked: boolean, theme: Theme) =>
  isLiked ? theme.palette.common.white : theme.palette.error.main;

const Root = styled(TileButton, {
  shouldForwardProp: (prop) => prop !== "isLiked",
})<{ isLiked: boolean }>(({ theme, isLiked }) => ({
  backgroundColor: getBackgroundColor(isLiked, theme),

  "&.Mui-disabled": {
    backgroundColor: getBackgroundColor(isLiked, theme),
  },

  "& svg": {
    color: isLiked ? theme.palette.error.main : theme.palette.common.white,
    transform: "scale(1)",
    transition: "transform 200ms ease-out",
  },

  "&:hover": {
    backgroundColor: getBackgroundColor(isLiked, theme),
  },
  "&:hover svg": {
    transform: "scale(1.2)",
  },
}));

export const TileLikeButton = (props: TileLikeButtonProps) => {
  const {
    isLiked = false,
    isLoading = false,
    onAction,
    "aria-label": ariaLabel,
    ...rest
  } = props;

  const handleAction = (action: "LIKE") => (e: React.MouseEvent) => {
    e.stopPropagation();
    onAction(e, action);
  };

  return (
    <Root
      aria-label={ariaLabel ?? "Like"}
      data-testid="btn-like"
      data-isliked={isLiked}
      onClick={handleAction("LIKE")}
      loading={isLoading}
      isLiked={isLiked}
      {...rest}
    >
      <FontAwesomeIcon icon={isLiked ? faHeart : faHeartRegular} />
    </Root>
  );
};
